var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDigital(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20,15h-4v-4c0-.552-.447-1-1-1s-1,.448-1,1v4H4c-2.206,0-4,1.794-4,4v1c0,2.206,1.794,4,4,4h16c2.206,0,4-1.794,4-4v-1c0-2.206-1.794-4-4-4Zm-15.5,6c-.828,0-1.5-.672-1.5-1.5s.672-1.5,1.5-1.5,1.5.672,1.5,1.5-.672,1.5-1.5,1.5Zm5,0c-.828,0-1.5-.672-1.5-1.5s.672-1.5,1.5-1.5,1.5.672,1.5,1.5-.672,1.5-1.5,1.5ZM15,5c1.817,0,3.526.708,4.812,1.993.391.391.391,1.024,0,1.414-.195.195-.451.293-.707.293s-.512-.098-.707-.293c-.907-.908-2.114-1.407-3.397-1.407s-2.49.5-3.397,1.407c-.39.391-1.023.391-1.414,0-.391-.39-.391-1.023,0-1.414,1.285-1.285,2.994-1.993,4.811-1.993Zm-8.778-1.182C8.485,1.392,11.684,0,15,0s6.516,1.392,8.778,3.818c.377.404.354,1.037-.05,1.414-.192.18-.438.269-.682.269-.268,0-.534-.107-.731-.318-1.886-2.022-4.552-3.182-7.315-3.182s-5.43,1.16-7.315,3.182c-.378.404-1.01.425-1.414.049-.404-.377-.426-1.01-.049-1.414Z",
    fill: "#67b173"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigital);
export default __webpack_public_path__ + "static/media/Digital.4e92eef785ba964fefc5418f9149f3e5.svg";
export { ForwardRef as ReactComponent };